import { useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import LoginService from "../../services/loginService";
import NotificationService from "../Notification/notificationService";

const PasswordRecoveryForm = () => {
  const [email, setEmail] = useState<string | undefined>(undefined);

  const { forgotPassword } = LoginService();
  const { success } = NotificationService();

  const forgot = () => {
    if (email) {
      forgotPassword(email).then((result) => {
        success("Email send, check your inbox for next steps.");
      });
    }
  };

  return (
    <Box sx={{ marginTop: "1rem" }}>
      <Box sx={{ marginBottom: "1rem" }}>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Box>
      <Box sx={{ marginLeft: "auto", width: "fit-content" }}>
        <Button
          variant="customBlueText"
          onClick={forgot}
          disabled={email === undefined}
        >
          Send
        </Button>
      </Box>
    </Box>
  );
};

export default PasswordRecoveryForm;
